import {createUuid} from '../lib/create-uuid'
import {toggleSkippedServiceDate} from '../service-schedules/build-out-logic'
import type {QuoteRequirement, Scheduling, ServiceTemplateRequirement} from './quote-builder-logic'
import type {Quote} from './schemas'

export {
    buildSummaryCounts,
    deriveServiceVisitDates,
    buildDraftJobs as generateJobs,
    quoteRequirementsToStageInput,
    schedulingCadenceForApi,
    templateRequirementsToApi,
    toggleSkippedServiceDate,
} from '../service-schedules/build-out-logic'
export {
    createEmptyScheduling,
    formatCadenceWeekdays,
    schedulingFromServiceSchedule,
} from '../service-schedules/schedule-draft-logic'

function createTemplateRequirementId(): string {
    return createUuid()
}

export function addTemplateRequirement(
    template: ServiceTemplateRequirement[],
    kind: ServiceTemplateRequirement['kind'],
): ServiceTemplateRequirement[] {
    return [
        ...template,
        {
            id: createTemplateRequirementId(),
            kind,
            typeId: '',
            qty: 1,
        },
    ]
}

export function removeTemplateRequirement(
    template: ServiceTemplateRequirement[],
    requirementId: string,
): ServiceTemplateRequirement[] {
    return template.filter((requirement) => requirement.id !== requirementId)
}

export function updateTemplateRequirementQty(
    template: ServiceTemplateRequirement[],
    requirementId: string,
    qty: number,
): ServiceTemplateRequirement[] {
    return template.map((requirement) =>
        requirement.id === requirementId ? {...requirement, qty: Math.max(1, qty)} : requirement,
    )
}

export function setTemplateRequirementType(
    template: ServiceTemplateRequirement[],
    requirementId: string,
    typeId: string,
): ServiceTemplateRequirement[] {
    return template.map((requirement) =>
        requirement.id === requirementId ? {...requirement, typeId} : requirement,
    )
}

export function toggleVisitSkip(scheduling: Scheduling, serviceDate: Date): Scheduling {
    return toggleSkippedServiceDate(scheduling, serviceDate)
}

export function countMappedRequirements(requirements: QuoteRequirement[]): number {
    return requirements.filter((requirement) =>
        requirement.kind === 'worker'
            ? requirement.workerTypeId.length > 0
            : requirement.rentalAssetTypeId.length > 0,
    ).length
}

export function formatQuoteReference(quote: Quote, customerName: string | null): string {
    const label = quote.name?.trim() || quote.id.slice(0, 8).toUpperCase()
    return customerName ? `${label} · ${customerName}` : label
}
